module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cf-pro-account-edit"
    }
  }, [_c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": "cf-pro-api-public"
    }
  }, [_vm._v("\n\t\t\tPublic Key\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicKey),
      expression: "publicKey"
    }],
    attrs: {
      "type": "text",
      "id": "cf-pro-api-public"
    },
    domProps: {
      "value": (_vm.publicKey)
    },
    on: {
      "change": _vm.publicKeyChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicKey = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": "cf-pro-api-secret"
    }
  }, [_vm._v("\n\t\t\tSecret Key\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secretKey),
      expression: "secretKey"
    }],
    attrs: {
      "type": "text",
      "id": "cf-pro-api-secret"
    },
    domProps: {
      "value": (_vm.secretKey)
    },
    on: {
      "change": _vm.secretKeyChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secretKey = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.connected) ? _c('p', [_vm._v("\n\t\tYou can find your API keys in your "), _c('a', {
    attrs: {
      "href": "https://app.calderaformspro.com/app#/account",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\tCaldera Forms Pro Account\n\t")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a873166e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Account/Edit.vue
// module id = 233
// module chunks = 1